module.exports = __webpack_public_path__ + "img/INTERIOR-IGNIS-2021-5.a06728c3.jpg";